const executionStatusPerTimeQuery = `
query execution_status_per_time($is_productive: String, $per: time_interval, $interval: Int, $project_id: String, $bundle_id: String, $allow_normal: Boolean, $allow_deleted: Boolean) {
    execution_status_per_time(is_productive: $is_productive, per: $per, interval: $interval, project_id: $project_id, bundle_id: $bundle_id, allow_normal: $allow_normal, allow_deleted: $allow_deleted) {
        time,
        status,
        count
    }
}  
`;

const executionStatusPerLocationQuery = `
query execution_status_per_location {
    execution_status_per_location {
        id,
        name,
        icon,
        ended_success,
        ended_error,
        ended_cancelled
        type_
    }
}
`;

export { executionStatusPerLocationQuery, executionStatusPerTimeQuery };
